const Svg = ({ className }: { className?: string }) => {
  return (
    <svg
      viewBox="0 0 12 8"
      className={className}
    >
      <path
        d="M12 1.70517L10.59 0.295166L6 4.87517L1.41 0.295166L-6.16331e-08 1.70517L6 7.70517L12 1.70517Z"
        fill="#456AD1"
      />
    </svg>
  );
};

export default Svg;
